export default "__VITE_ASSET__5f44c674__"